import React from 'react';
import { KatButton, KatColumn, KatRow } from '@amzn/katal-react';
import { AuthenticationState } from '../hooks/useTrimContext';
import { usePNFTranslation } from 'src/common/helpers';

interface PNFDisputeSignInPageProps {
  authenticationState?: AuthenticationState ;
}

const PNFDisputeSignInPage: React.FC<PNFDisputeSignInPageProps> = (props: PNFDisputeSignInPageProps) => {
  const t = usePNFTranslation();
  const { authenticationState } = props;

  const handleSignInClick = () => {
    window.location.href = authenticationState?.signInUrl || '';
  };
  return (
    <div className="page-padding">
      {/* Page container for page level padding */}
      <KatRow className="d-flex justify-content-between">
        <KatColumn lg={6} md={6} xs={6}>
          <KatRow className="pt-4">
            <h1>
              {t('pnf-dispute-form-title')}
            </h1>
          </KatRow>
          <KatRow className="pt-2">
            <h2>{t('public-notice-form-required-sign-in-auth-title')}</h2>
          </KatRow>
          <KatRow>
            {t('pnf-dispute-sign-in-required-text')}
          </KatRow>
          <KatRow className="pt-2 align-items-center">
            <KatButton
              id="pnf-website-sign-in-button"
              variant="primary"
              onClick={handleSignInClick}
            >
              {t('public-notice-form-sign-in-button')}
            </KatButton>
            <span className="ms-1" id="create-account">
              {t('public-notice-form-required-sign-in-new-to-amazon')}
              <a className="ms-1" href={authenticationState?.registerUrl}>
                {t('public-notice-form-required-sign-in-create-an-account')}
              </a>
            </span>
          </KatRow>
          <KatRow className="pt-4">
            <h2>{t('pnf-dispute-description-title')}</h2>
          </KatRow>
          <KatRow>
            <p>{t('pnf-dispute-description-text')}</p>
            <p>{t('pnf-dispute-description-time-duration')}</p>
          </KatRow>
        </KatColumn>
      </KatRow>
    </div>
  );
};
export default PNFDisputeSignInPage;
